import { ResponseTemplateRequest } from "@shared/dtos/requests/practiceRequests.dto"
import {
  ResponseTemplateCreationResponse,
  ResponseTemplateResponse,
} from "@shared/dtos/responses/practiceResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getAll = (practiceId: string): Promise<ResponseTemplateResponse[]> => {
  return axiosAuth({
    url: `/practices/${practiceId}/responsetemplates`,
    method: "get",
  }).then((resp) => resp.data)
}

export const create = (practiceId: string, req: ResponseTemplateRequest): Promise<ResponseTemplateCreationResponse> => {
  return axiosAuth({
    url: `/practices/${practiceId}/responsetemplates`,
    method: "post",
    data: req,
  }).then((resp) => resp.data)
}

export const edit = (practiceId: string, templateId: string, req: ResponseTemplateRequest): Promise<void> => {
  return axiosAuth({
    url: `/practices/${practiceId}/responsetemplates/${templateId}`,
    method: "put",
    data: req,
  }).then(() => undefined)
}

export const remove = (practiceId: string, templateId: string): Promise<void> => {
  return axiosAuth({
    url: `/practices/${practiceId}/responsetemplates/${templateId}`,
    method: "delete",
  }).then(() => undefined)
}
